<script setup lang="ts">
import { computed } from 'vue';

  interface Props {
    name: string,
    color?: string
    size?: 'sm' | 'md' | 'lg' | 'xl'
    fill?: boolean
  }
  const props = defineProps<Props>();

  const sizeMap = {
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px'
  };

  const iconStyle = computed(() => {
    const style: Record<string, string> = {};
    if (props.color) {
      style.color = props.color;
    }
    const sizeKey = props.size ?? 'md';
    style.fontSize = sizeMap[sizeKey];
    if (props.fill) {
      style.fontVariationSettings = "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24";
    }
    return style;
  });
</script>

<template>
    <span class="material-symbols-outlined" :style="iconStyle" aria-hidden="true">{{ props.name }}</span>
</template>